import { SecondaryNavigation } from '@app/shared/components/secondary-navigation/SecondaryNavigation';
import { NavigationItem } from '@app/shared/components/secondary-navigation/secondary-navigation-types';
import { RouteConstants } from '../../RouteConstants';
import { useLocale } from '@app/core/hooks/useLocale';
import { useAppSelector } from '@app/core/hooks/redux-hooks';

export const ValuationInputsNavigation = () => {
  const { l } = useLocale();
  const discountRateOverrideEnabled = useAppSelector(
    (state) => state.uiValues.discountRateOverrideEnabled
  );

  const navigationItems: NavigationItem[] = [
    {
      label: l('_CapmAssumptions'),
      route: `../${RouteConstants.CapmAssumptions}`,
    },
    ...(discountRateOverrideEnabled
      ? [
          {
            label: l('_DiscountRateOverride'),
            route: `../${RouteConstants.DiscountRateOverride}`,
          },
        ]
      : []),
    {
      label: 'DLOC',
      route: `../${RouteConstants.DLOC}`,
    },
    {
      label: 'DLOM',
      route: `../${RouteConstants.DLOM}`,
    },
  ];

  return <SecondaryNavigation navigationItems={navigationItems} />;
};
